module.exports = __webpack_public_path__ + "img/pr-9.c9ecf4db.png";